import React from "react";
import { cx } from "class-variance-authority";

import "./OrderedList.scss";

type OrderedListProps = React.ComponentProps<"ol">;

export function OrderedList({
    children,
    className,
    ...rest
}: React.PropsWithChildren<OrderedListProps>) {
    const classes = cx("ordered-list", className);

    return (
        <ol className={classes} {...rest}>
            {children}
        </ol>
    );
}
